const signals = [
  'сотрудники соглашаются на встрече, но не выполняют договорённости;',
  'руководитель слишком часто давит должностью вместо аргументов;',
  'сложные разговоры постоянно откладываются;',
  'руководитель избегает конфронтации и уступает заранее;',
  'сильные сотрудники начинают диктовать условия;',
  'подразделения постоянно конфликтуют за ресурсы;',
  'руководитель не умеет отстаивать бюджет;',
  'на переговорах слишком быстро предоставляются уступки;',
  'руководитель начинает оправдываться под давлением;',
  'переговоры превращаются в спор о том, кто прав;',
  'решения принимаются, но не исполняются;',
  'собственник или вышестоящее руководство легко меняет позицию руководителя;',
  'руководителю сложно говорить «нет»;',
  'важные переговоры заканчиваются неопределёнными договорённостями.',
];

export default function WhenToStrengthen() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Когда руководителю необходимо усилить переговорные навыки
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Сигналы, что руководителю не хватает переговорных инструментов и ситуация требует вмешательства
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto mb-10">
          {signals.map((s, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-gray-50 rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-alert-line text-amber-500 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{s}</span>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Обсудить переговорную задачу
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}